export const priceFormat = (data) => {
  if (data) {
    const dataFormat = data.toString();
    if (dataFormat.trim() && dataFormat.trim() !== '') {
      const price = dataFormat
        .replace('$', '')
        .replace(/,/g, '')
        .trim();
      return `$${parseFloat(price).toFixed(2)}`;
    }
    return '$0.00';
  }
  return '$0.00';
};

export const priceFormatAll = (data) => {
  if (data >= 0) {
    return priceFormat(data);
  }
  return priceFormatNegative(Math.abs(data));
};

export const priceIntFormat = (data) => {
  if (data) {
    const dataFormat = data.toString();
    if (dataFormat.trim() && dataFormat.trim() !== '') {
      const price = dataFormat
        .replace('$', '')
        .replace(/,/g, '')
        .trim();
      return `$${parseInt((price, 10).toFixed(2))}`;
    }
    return '$0.00';
  }
  return '$0.00';
};

export const priceFormatNegative = (data) => {
  if (data) {
    const dataFormat = data.toString();
    if (dataFormat.trim() && dataFormat.trim() !== '') {
      const price = dataFormat.replace('$', '').trim();
      return `-$${parseFloat(price).toFixed(2)}`;
    }
    return '-$0.00';
  }
  return '-$0.00';
};

export const priceFormatWithoutCurrency = (data) => {
  if (data) {
    const dataFormat = data.toString();
    if (dataFormat.trim() && dataFormat.trim() !== '') {
      const price = dataFormat.replace('$', '').trim();
      return `${parseFloat(price).toFixed(2)}`;
    }
    return '0.00';
  }
  return '0.00';
};

export const discountPercentage = (data) => {
  if (data) {
    const dataFormat = data.toString();
    if (dataFormat.trim() && dataFormat.trim() !== '') {
      const price = dataFormat.replace('$', '').trim();
      return `${parseFloat(price).toFixed(0)}%`;
    }
    return '0';
  }
  return '0';
};

export const discountedText = (originalAmt, discountedAmt = null, wasTextRequired = false) => {
  const discountAvailable = discountedAmt && discountedAmt > 0 && priceFormat(discountedAmt) !== originalAmt;
  if (discountAvailable && wasTextRequired) {
    return `${priceFormat(discountedAmt)} was <strike>${priceFormat(originalAmt)}</strike>`;
  }
  return discountAvailable ? `<strike>${priceFormat(originalAmt)}</strike> ${priceFormat(discountedAmt)}` : `${priceFormat(originalAmt)}`;
};
